module.exports = __webpack_public_path__ + "img/logo.538041ab.svg";